<form id="ir_checkForm" class="position-relative" (ngSubmit)="submitFullForm()" [formGroup]="shareholderForm"
      *ngIf="!showSummary && !showThankYou">
    <div style="margin:25px 0;" id="message_area" *ngIf="errorMessage">
        {{errorMessage}}
    </div>

    <div class="row">
        <div class="form-group col-12 col-md-6 mb-3">
            <label for="input-email">Email</label>
            <input class="form-control" type="email" formControlName="email"
                   id="input-email">
            <span class="msg-form-error"
                  *ngIf="validateForm && formControlErrors('email').required">Pole obowiązkowe</span>
            <span class="msg-form-error"
                  *ngIf="validateForm && formControlErrors('email').email">Email niepoprawny</span>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12 subject-select ">
            <div class="sectionSelect country">
                <label>Osoba fizyczna/Firma</label>
                <select formControlName="companySelect" class="form-control  custom-select ">
                    <option selected value="person">Osoba fizyczna</option>
                    <option value="company">Firma</option>
                </select>
            </div>
        </div>
    </div>

    <div id="personalForm" *ngIf="isPerson">
        <h5>Osoba Fizyczna</h5>
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label>Imię</label>
                <input class="form-control" type="text" formControlName="firstname">
                <span class="msg-form-error" *ngIf="validateForm && formControlErrors('firstname').required">Pole obowiązkowe</span>

            </div>
            <div class="form-group col-12 col-md-6">
                <label>Nazwisko</label>
                <input class="form-control" type="text" formControlName="lastname">
                <span class="msg-form-error" *ngIf="validateForm && formControlErrors('lastname').required">Pole obowiązkowe</span>

            </div>
            <div class="form-group col-12 col-md-6">
                <label>PESEL</label>
                <input class="form-control" type="text" formControlName="pesel" minlength="11" maxlength="11">
                <span class="msg-form-error"
                      *ngIf="validateForm && formControlErrors('pesel').required">Pole obowiązkowe</span>
                <span class="msg-form-error"
                      *ngIf="validateForm && formControlErrors('pesel').minlength">Minimalna liczba znaków to 11</span>
                <span class="msg-form-error"
                      *ngIf="validateForm && formControlErrors('pesel').maxlength">Maksymalna liczba znaków to 11</span>

            </div>

        </div>
    </div>
    <div *ngIf="!isPerson">
        <div class="row">
            <div class="col-12">
                <h5>Firma</h5>
            </div>
            <div class="form-group col-12 col-md-6">
                <label>Nazwa</label>
                <input class="form-control" type="text" formControlName="companyName">
                <span class="msg-form-error"
                      *ngIf="validateForm && formControlErrors('companyName').required">Pole obowiązkowe</span>
            </div>
            <div class="form-group col-12 col-md-6">
                <label>REGON</label>
                <input class="form-control" type="text" formControlName="regon">
                <span class="msg-form-error"
                      *ngIf="validateForm && formControlErrors('regon').required">Pole obowiązkowe</span>
            </div>

        </div>

    </div>

    <div class="row">
        <div class="form-group col-12 col-md-6">
            <label for="input-phone">Telefon</label>
            <input class="form-control" type="text" formControlName="phone" id="input-phone"/>
        </div>
    </div>
    <hr/>

    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-md-12">
                    <label>Nr rachunku maklerskiego</label>
                    <input class="form-control" type="text" formControlName="brokerage"
                           id="input-brokerage">
                    <span class="msg-form-error"
                          *ngIf="validateForm && formControlErrors('brokerage').required">Pole obowiązkowe</span>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="form-group col-md-12">
                    <label>Podmiot prowadzący rachunek
                        maklerski</label>
                    <input class="form-control" type="text" formControlName="makler"
                           id="input-makler">
                    <span class="msg-form-error"
                          *ngIf="validateForm && formControlErrors('makler').required">Pole obowiązkowe</span>
                </div>
            </div>
        </div>
    </div>

    <hr/>

    <div class="row">
        <div class="col-12">
            <h5>Akcje</h5>
        </div>
        <div class="form-group col-12 ">
            <label>Liczba posiadanych akcji</label>
            <input class="form-control" type="number" min="1"
                   formControlName="assetsTotalQty"
                   id="input-assetsTotalQty" NumbersOnly [allowDecimals]="false" [allowSign]="false">
            <span class="msg-form-error"
                  *ngIf="validateForm && formControlErrors('assetsTotalQty').required">Pole obowiązkowe</span>
            <span class="msg-form-error"
                  *ngIf="validateForm && assetsNumberInvalid">Wprowadzona liczba posiadanych akcji nie jest zgodna z wprowadzoną sumą akcji w odcinkach.</span>
        </div>
        <div class="assetsList col-12" id="assetsList">
            <div class="row row1" *ngFor="let asset of assets.controls; let first = first; let idx = index;">
                <ng-container [formGroup]="asset">
                    <div class="form-group px-1 col-12 col-lg-3 d-flex flex-column justify-content-between">
                        <label *ngIf="first">Numery odcinka<br/>(od .... do ....)</label>
                        <input class="form-control" type="text"
                               formControlName="number">
                        <span class="msg-form-error"
                              *ngIf="validateForm && asset.get('number').errors">Pole obowiązkowe</span>
                    </div>
                    <div class="form-group px-1 col-12 col-lg-1 d-flex flex-column justify-content-between">
                        <label *ngIf="first">Liczba akcji w odcinku</label>
                        <input class="form-control" type="number" min="1" step="1" formControlName="qty"
                               NumbersOnly [allowDecimals]="false" [allowSign]="false" style="padding: 9px 5px;">
                        <span class="msg-form-error"
                              *ngIf="validateForm && asset.get('qty').errors">Pole obowiązkowe</span>
                    </div>
                    <div class="form-group px-1 col-12 col-lg-2 d-flex flex-column justify-content-between">
                        <label *ngIf="first">Cena nabycia akcji (szt.)</label>
                        <input class="form-control" type="number" min="1"
                               formControlName="price"
                               id="input-assetPrice" NumbersOnly [allowDecimals]="true" [allowSign]="true">
                    </div>
                    <div class="form-group px-1 col-12 col-lg-2 d-flex flex-column justify-content-between">
                        <label *ngIf="first">Seria akcji</label>
                        <input class="form-control" type="text"
                               formControlName="set"
                               id="input-assetSet">
                        <span class="msg-form-error"
                              *ngIf="validateForm && asset.get('set').errors">Pole obowiązkowe</span>
                    </div>
                    <div class="form-group px-1 col-12 col-lg-3 d-flex flex-column justify-content-between">
                        <label *ngIf="first">Data nabycia</label>
                        <input class="form-control" type="date"
                               formControlName="date"
                               id="input-assetDate">
                    </div>
                    <div class="form-group px-0 col-12 col-lg-1 d-flex flex-column justify-content-between">
                        <label *ngIf="first">&nbsp;</label>
                        <button *ngIf="!first" class="btn btn-primary" (click)="removeAssetROw(idx)">usuń</button>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="col-12 text-right">
            <button class="btn btn-primary" type="button" (click)="addAssetRow()">Dodaj kolejny odcinek akcji</button>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mt-5 mb-3">
            <div class="checkbox">
                <label>
                    <input type="checkbox" formControlName="zgoda" id="zgoda"/>
                    <span class="custom-checkbox"></span>
                    Akceptuję <a target="_blank"
                                 href="/downloads/Klauzula Informacyjna dla Akcjonariuszy Zortrax S.A..pdf">
                    Klauzulę Informacyjna dla Akcjonariuszy Zortrax S.A..pdf
                </a>
                </label>
                <br/>
                <span class="msg-form-error"
                      *ngIf="validateForm && formControlErrors('zgoda').required">Pole obowiązkowe</span>
            </div>
        </div>
    </div>
    <div class="col-12 submit-box">
        <div class="row">
            <div class="row w-100">
                <div class="col-12 my-3">
                  <span class="msg-form-error"
                        *ngIf="validateForm && !shareholderForm.valid">
                      Formularz zawiera błędy. Sprawdź wszystkie pola i postępuj zgodnie z instrukcjami.
                  </span>
                </div>
                <br/>
                <div class="col-4  d-flex justify-content-center">
                    <button class="btn btn-primary btn-block"
                            id="submit_form_btn"
                            (click)="preValidate()">Przejdź do podsumowania
                    </button>
                </div>
            </div>
        </div>
    </div>

</form>
<ng-container *ngIf="showThankYou">
    <h5>Dziękujemy</h5><br/><br/>
    <p>Dane zostały zapisane do rejestru</p>
</ng-container>

<ng-container *ngIf="showSummary">
    <div class="confirmWindow">
        <h5>Potwierdź poprawnosć składanych danych</h5>

        <span>Email: {{validatedData.email || 'nie podano'}}<br/></span>

        <ng-container *ngIf="validatedData.companySelect === 'person'">
            <span>Imię: {{validatedData.firstname || 'nie podano'}}<br/></span>
            <span>Nazwisko: {{validatedData.lastname || 'nie podano'}}<br/></span>
            <span>Data urodzenia: {{validatedData.birthDate || 'nie podano'}}<br/></span>
            <span>PESEL: {{validatedData.pesel || 'nie podano'}}<br/></span>
            <span>Numer dodwodu osobistego: {{validatedData.idnumber || 'nie podano'}}<br/></span>
        </ng-container>
        <ng-container *ngIf="validatedData.companySelect === 'company'">
            <span>Nazwa Firmy: {{validatedData.companyName || 'nie podano'}} <br/></span>
            <span>Nip: {{validatedData.nip || 'nie podano'}} <br/></span>
            <span>KRS: {{validatedData.krs || 'nie podano'}} <br/></span>
            <span>REGON: {{validatedData.regon || 'nie podano'}} <br/></span>
        </ng-container>

        <br/>
<!--        <span>Adres: {{validatedData.street}}  {{validatedData.building}} {{validatedData.apartment }}-->
<!--            <br/>-->
<!--            {{validatedData.postalCode}} {{validatedData.city }}{{validatedData.country}}-->
<!--        </span>-->
        <br/> <br/>
<!--        <ng-container *ngIf="validatedData.correspondenceSame">-->
<!--        <span>Adres do korespondencji:-->

<!--            {{validatedData.correspondenceStreet }}-->
<!--            {{validatedData.correspondenceBuilding }}-->
<!--            {{validatedData.correspondenceApartment}}-->
<!--            <br/>-->
<!--            {{validatedData.correspondencePostalCode }}-->
<!--            {{validatedData.correspondenceCity }}-->
<!--            {{validatedData.correspondenceCountry }}-->

<!--         </span>-->
<!--        </ng-container>-->
        <br/><br/>
        <span>Numer rachunku maklerskiego: {{validatedData.brokerage || 'nie podano'}} </span>
        <br/>
        <span>Podmiot prowadzący rachunek maklerski: {{validatedData.makler || 'nie podano'}} </span>
        <br/>
        <span> Całkowita liczba posiadanych akcji:  {{validatedData.assetsTotalQty || 'nie podano'}}</span>
        <br/><br/>
        <div class="assets">
            <table class="table">
                <tr>
                    <th>Numer odcinka</th>
                    <th>Ilość akcji w odcinku</th>
                    <th>Cena Nabycia</th>
                    <th>Seria akcji</th>
                    <th> Data Nabycia akcji</th>
                </tr>
                <tr class="asset" *ngFor="let assetRow of shareholderForm.value.assets">
                    <td>{{assetRow.number || 'nie podano'}}</td>
                    <td>{{assetRow.qty || 'nie podano'}}</td>
                    <td>{{assetRow.price || 'nie podano'}}</td>
                    <td>{{assetRow.set || 'nie podano'}}</td>
                    <td>{{assetRow.date || 'nie podano'}}</td>

                </tr>
            </table>
        </div>
        <div class="text text-center my-2">
            <h5><strong>Oświadczam, że dane podane przeze mnie w formularzu są prawdziwe i zgodne ze stanem
                faktycznym.</strong></h5>
        </div>
        <div class="buttons d-flex flex-column flex-md-row justify-content-end mt-4">
            <button class="btn  btn-outline mr-md-4 mb-3 mb-md-0 col-md-4 col-12 " type="button"
                    (click)="showSummary = false">Anuluj
            </button>
            <button class="btn btn-primary btn-block  col-md-4 col-12" id="confirm" (click)="submitFullForm()">
                Powierdzam
            </button>
        </div>
    </div>
</ng-container>
